import { TranslationKeys } from "../../contexts/TranslationKeys";
import { Translator } from "../../contexts/translator";
import { Filter } from "../../models/Filter";
import { MultiSelectOption } from "../../models/MultiSelectOption";
import { SearchTerm } from "../../models/search/SearchTerm";

export const customFilterBuilder = (searchOnNames: string[], translate: Translator, filters?: Filter[], searchTerm?: SearchTerm): string => {
    let filter: string[] = [];

    if (filters?.length) {
        filter.push(filterQuery(searchOnNames, translate, filters));
    }

    if (searchTerm?.value) {
        const qoutaionMark: string = searchTerm?.value?.includes('"') ? "'" : '"';
        const newSearchValue = searchTerm?.value?.replaceAll('%', '%25').replaceAll('#', '%23').replaceAll('&', '%26');
        filter.push(`${searchTerm.accessor}==${qoutaionMark}*${newSearchValue}*${qoutaionMark}`);
    }

    return filter.length === 0 ? '' : `&filter=${filter.join(';')}`;
};
const filterQuery = (searchOnNames: string[], translate: Translator, filters?: Filter[]): string => {
    let appliedFilters: string[] = [];

    filters?.forEach(filter => {
        if (filter.key === 'days') {
            appliedFilters.push(selectedDeviceDaysFilter(filter?.selected, searchOnNames, translate));
        }
        else {
            filter.operator ?
                appliedFilters.push(filter.key + filter.operator + "(" + filter.selected?.map(selected => selected.value).join(",") + ")")
                : appliedFilters.push(filter.key + "=in=(" + filter.selected?.map(selected => selected.value).join(",") + ")");
        }
    });

    return appliedFilters.join(';');
};

const selectedDeviceDaysFilter = (selectedDays: MultiSelectOption[], searchOnNames: string[], translate: Translator): string => {
    let dayQueryPortion: string[] = [];
    const days: string[] = [
        translate.byKey(TranslationKeys.monday), 
        translate.byKey(TranslationKeys.tuesday), 
        translate.byKey(TranslationKeys.wednesday), 
        translate.byKey(TranslationKeys.thursday), 
        translate.byKey(TranslationKeys.friday), 
        translate.byKey(TranslationKeys.saturday), 
        translate.byKey(TranslationKeys.sunday), 
        translate.byKey(TranslationKeys.holiday)
    ];

    for (let x = 0; x < selectedDays.length; x++) {
        for (let i = 0; i < days.length; i++) {
            if (selectedDays[x].label.toLowerCase() === days[i].toLowerCase()) {
                dayQueryPortion.push(`${searchOnNames[i]}=='1'`);
            }
        }
    }

    return dayQueryPortion.join(';');
};

export const createProfileFilter = (profileId?: number, label?: string, showFilterChips?: boolean) => {
    if (profileId) {
        const profileFilter = {
            key: "profile.id",
            label: `${label}`,
            options: [{ value: `${profileId}`, label: `${profileId}` }],
            selected: [{ value: `${profileId}`, label: `${profileId}` }],
            showFilterChips: showFilterChips,
        };
        return profileFilter;
    }
    return undefined;
};
